export function ContactChangeEmailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
      <path
        d="M7.61905 11.4286C7.61905 8.48 10.0038 6.09524 12.9524 6.09524C13.7752 6.09524 14.5448 6.28571 15.2381 6.61333V1.52381C15.2381 0.685714 14.5524 0 13.7143 0H1.52381C0.685714 0 0 0.685714 0 1.52381V10.6667C0 11.5048 0.685714 12.1905 1.52381 12.1905H7.68C7.6419 11.939 7.61905 11.6876 7.61905 11.4286ZM1.52381 1.52381L7.61905 5.33333L13.7143 1.52381V3.04762L7.61905 6.85714L1.52381 3.04762V1.52381ZM11.6876 13.7143L8.99048 11.0171L10.0648 9.94286L11.68 11.5581L14.9105 8.32762L16 9.40191L11.6876 13.7143Z"
        fill="black"
      />
    </svg>
  );
}
